var _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHierarchyFiles = function SvgHierarchyFiles(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 18.998V23.998",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 28.998V33.998",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 11V13C5.00977 13.5304 5.22048 14.0391 5.59555 14.4142C5.97062 14.7893 6.47933 15 7.00977 15H9.00977",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 39V41C5.00977 41.5304 5.22048 42.0391 5.59555 42.4142C5.97062 42.7893 6.47933 43 7.00977 43H9.00977",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.998H20",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 42.998H20",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00977 0.998047V5.99805",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 19C41 19.5304 40.7893 20.0391 40.4142 20.4142C40.0391 20.7893 39.5304 21 39 21H27C26.4696 21 25.9609 20.7893 25.5858 20.4142C25.2107 20.0391 25 19.5304 25 19V3C25 2.46957 25.2107 1.96086 25.5858 1.58579C25.9609 1.21071 26.4696 1 27 1H33C34.2659 1.06864 35.4703 1.5675 36.414 2.414L39.586 5.586C40.4325 6.52969 40.9314 7.73415 41 9V19Z",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 1.1377V5.9997C34 6.53013 34.2107 7.03884 34.5858 7.41391C34.9609 7.78898 35.4696 7.9997 36 7.9997H40.858",
    fill: "#0258FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 1.1377V5.9997C34 6.53013 34.2107 7.03884 34.5858 7.41391C34.9609 7.78898 35.4696 7.9997 36 7.9997H40.858",
    stroke: "#0258FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 45C41 45.5304 40.7893 46.0391 40.4142 46.4142C40.0391 46.7893 39.5304 47 39 47H27C26.4696 47 25.9609 46.7893 25.5858 46.4142C25.2107 46.0391 25 45.5304 25 45V29C25 28.4696 25.2107 27.9609 25.5858 27.5858C25.9609 27.2107 26.4696 27 27 27H33.228C33.79 27 34.3466 27.1107 34.8658 27.3259C35.385 27.5411 35.8567 27.8565 36.254 28.254L39.586 31.586C40.4325 32.5297 40.9314 33.7341 41 35V45Z",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 27.0723V32.0003C34 32.5307 34.2107 33.0394 34.5858 33.4145C34.9609 33.7896 35.4696 34.0003 36 34.0003H40.86",
    fill: "#0258FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 27.0723V32.0003C34 32.5307 34.2107 33.0394 34.5858 33.4145C34.9609 33.7896 35.4696 34.0003 36 34.0003H40.86",
    stroke: "#0258FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHierarchyFiles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hierarchy-files.3cb65602.svg";
export { ForwardRef as ReactComponent };